/**
 * Pickr (@simonwep/pickr) 래퍼 – Pickr import 를 이 파일 안에만 격리.
 * 외부 코드는 Pickr 를 직접 import 하지 말고 이 래퍼를 통해서만 접근한다.
 *
 * 사용:
 *   import { PickrWrapper } from "../../components/PickrWrapper";
 *   const instance = PickrWrapper.create({ el, default: "#ff0000", ... });
 *   instance.on("change", (color: PickrHSVaColor) => { ... });
 */
import Pickr from "@simonwep/pickr";

// Re-export types so callers don't need to import from @simonwep/pickr directly
export type PickrInstance = Pickr;
export type PickrHSVaColor = Pickr.HSVaColor;
export type PickrOptions = Pickr.Options;

export class PickrWrapper {
  /**
   * Pickr 인스턴스를 생성한다.
   * `Pickr.create(options)` 와 동일한 시그니처.
   */
  static create(options: Pickr.Options): Pickr {
    return Pickr.create(options);
  }
}
